import React, { useMemo } from 'react';
import { Cell, CellProps } from 'react-table';
import moment from 'moment/moment';

import { useI18n } from 'i18n';
import { ITepDevice } from 'types/tep';
import { TepDeviceUriCell } from 'components/organisms/tep/devices/uri-cell';
import { TepDeviceActionsCell } from 'components/organisms/tep/devices/actions-cell';

export const useTepEntryPassesColumns = () => {
  const { fc } = useI18n();

  const getDateCell = ({ cell }: CellProps<ITepDevice>) => (
    <>{cell.value ? moment(cell.value).format('YYYY-MM-DD') : '-'}</>
  );

  const getUriCell = ({ cell }: { cell: Cell<ITepDevice> }) => <TepDeviceUriCell entryPass={cell.row.original} />;

  const getActionsCell = ({ cell }: { cell: Cell<ITepDevice> }) => <TepDeviceActionsCell device={cell.row.original} />;

  return useMemo(
    () => [
      { Header: fc('device name'), accessor: 'name' },
      { Header: fc('device imei'), accessor: 'device.uri', Cell: getUriCell },
      { Header: fc('added at'), accessor: 'createdAt', Cell: getDateCell },
      {
        Header: fc('actions'),
        accessor: 'actions',
        width: 200,
        minWidth: 200,
        Cell: getActionsCell,
        isFlexUnset: true,
      },
    ],
    [],
  );
};
